// extracted by mini-css-extract-plugin
module.exports = {"main":"Diffirence_main__1VQyc","wrap":"Diffirence_wrap__2pW7p","item":"Diffirence_item__32XB_","left":"Diffirence_left__SFWo5","right":"Diffirence_right__16D16"};